import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const languages = [
    { 
      code: 'pt', 
      name: 'Português', 
      flag: 'https://flagcdn.com/24x18/br.png',
      flag2x: 'https://flagcdn.com/48x36/br.png'
    },
    { 
      code: 'en', 
      name: 'English', 
      flag: 'https://flagcdn.com/24x18/gb.png',
      flag2x: 'https://flagcdn.com/48x36/gb.png'
    },
    { 
      code: 'es', 
      name: 'Español', 
      flag: 'https://flagcdn.com/24x18/es.png',
      flag2x: 'https://flagcdn.com/48x36/es.png'
    },
    { 
      code: 'fr', 
      name: 'Français', 
      flag: 'https://flagcdn.com/24x18/fr.png',
      flag2x: 'https://flagcdn.com/48x36/fr.png'
    },
    { 
      code: 'it', 
      name: 'Italiano', 
      flag: 'https://flagcdn.com/24x18/it.png',
      flag2x: 'https://flagcdn.com/48x36/it.png'
    }
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-selector">
      <div className="flag-container">
        {languages.map((lang) => (
          <img
            key={lang.code}
            src={lang.flag}
            srcSet={`${lang.flag2x} 2x`}
            alt={`${lang.name} flag`}
            className={`flag ${i18n.language === lang.code ? 'active' : ''}`}
            onClick={() => changeLanguage(lang.code)}
            title={lang.name}
          />
        ))}
      </div>
    </div>
  );
};

export default LanguageSelector; 